import { render, staticRenderFns } from "./navLeftShopinfo.vue?vue&type=template&id=91e70ea0"
import script from "./navLeftShopinfo.vue?vue&type=script&lang=js"
export * from "./navLeftShopinfo.vue?vue&type=script&lang=js"
import style0 from "./navLeftShopinfo.vue?vue&type=style&index=0&id=91e70ea0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports